module.exports = __webpack_public_path__ + "static/media/comunication.80ef17c2.png";